function BasicInfo({
  user,
  makeEvents,
  joinedCount,
  visibleSection,
  onClickDetail,
}) {
  const getCount = (data) => {
    if (Array.isArray(data)) {
      return data.length;
    }

    if (typeof data === 'string') {
      try {
        const parsed = JSON.parse(data);
        return Array.isArray(parsed) ? parsed.length : 0;
      } catch {
        return 0;
      }
    }

    return 0;
  };

  const basicStats = [
    {
      label: 'ルーム作成数',
      value: makeEvents?.length || 0,
      clickable: true,
      isActive: visibleSection === 'makeEvents',
    },
    {
      label: 'ルーム参加数',
      value: joinedCount,
      clickable: true,
      isActive: visibleSection === 'events',
    },
    {
      label: 'フォロー数',
      value: getCount(user?.follow),
      clickable: true,
      isActive: visibleSection === 'follow',
    },
    {
      label: 'ライバル数',
      value: getCount(user?.rivals),
      clickable: true,
      isActive: visibleSection === 'rival',
    },
  ];

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', padding: '16px', gap: '12px' }}>
      {basicStats.map((item, i) => (
        <div
          key={i}
          onClick={item.clickable ? () => onClickDetail?.(item.label) : undefined}
          onMouseEnter={(e) => {
            if (item.clickable && !item.isActive) {
              e.currentTarget.style.color = '#007bff';
              e.currentTarget.style.borderColor = '#007bff';
            }
          }}
          onMouseLeave={(e) => {
            if (item.clickable && !item.isActive) {
              e.currentTarget.style.color = '';
              e.currentTarget.style.borderColor = '#ccc';
            }
          }}
          style={{
            cursor: item.clickable ? 'pointer' : 'default',
            padding: '8px 12px',
            border: item.isActive ? '1px solid #007bff' : '1px solid #ccc',
            borderRadius: '6px',
            fontWeight: 'bold',
            minWidth: '120px',
            color: item.isActive ? '#007bff' : 'inherit',
            backgroundColor: item.isActive ? '#f0f7ff' : '#fff',
            transition: 'all 0.2s ease',
          }}
        >
          {item.label}: {item.value}
        </div>
      ))}
    </div>
  );
}

export default BasicInfo;
